import styled from "styled-components";
import { HeaderWithBack } from "../components/molecules/Header";
import { Button } from "../components/atoms/Button";
import { Breadcrumbs } from "../components/atoms/Breadcrumbs";
import { PlayerBadge } from "../components/molecules/PlayerBadge";
import { formatBalance } from "../utils/formatters";
import { ExpenseModifier } from "../components/atoms/ExpenseModifier";

const Container = styled.div`
  width: 80%;
`;

const PlayersContainer = styled.div`
  margin: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  min-height: 4rem;
`;

const PlayerDataContainer = styled.span`
  box-shadow: 0 0 0.2rem #000a;
  border-radius: 5px;
  margin: 1rem;
  min-height: 4rem;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
`;

export const ModifyData = ({
  players,
  handleAddExpense,
  handleRemoveExpense,
  handleUpdateExpense,
  handleModificationConfirmed,
  handleBackButtonClicked,
}) => {
  const totalBalance = players.reduce((acc, player) => acc + player.balance, 0);

  const accumulate = (array) => array.reduce((acc, value) => acc + value, 0);

  const getPlayerExpenses = (player) => accumulate(player.expenses);

  return (
    <Container>
      <HeaderWithBack handleBackButtonClicked={handleBackButtonClicked}>
        <h3>
          Zysk z hunta:{" "}
          <b>
            {formatBalance(
              totalBalance -
                accumulate(players.map((player) => getPlayerExpenses(player)))
            )}
          </b>
        </h3>
      </HeaderWithBack>
      <Breadcrumbs>
        Klikając na czerwony guzik z + możesz dodać dodatkowe wydatki (np. imbu)
      </Breadcrumbs>
      <PlayersContainer>
        {players.map((player, playerIndex) => (
          <PlayerDataContainer key={playerIndex}>
            <PlayerBadge
              name={player.name}
              balance={player.balance - getPlayerExpenses(player)}
              handleAddExpense={() => handleAddExpense(playerIndex)}
            />
            {player.expenses.map((amount, expenseIndex) => (
              <ExpenseModifier
                handleRemoveExpense={() =>
                  handleRemoveExpense(playerIndex, expenseIndex)
                }
                handleUpdateExpense={(value) =>
                  handleUpdateExpense(playerIndex, expenseIndex, value)
                }
                amount={amount}
                key={`${playerIndex}${expenseIndex}`}
              />
            ))}
          </PlayerDataContainer>
        ))}
      </PlayersContainer>
      <br />
      <Button handleClick={() => handleModificationConfirmed()}>Dalej</Button>
    </Container>
  );
};
